import { render, staticRenderFns } from "./EditSpaceDashboard.vue?vue&type=template&id=e37480c4"
import script from "./EditSpaceDashboard.vue?vue&type=script&lang=js"
export * from "./EditSpaceDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports